import React from 'react';
import '../App.css';

function TeacherModal({ teacher, onClose }) {
  if (!teacher) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <span>&times;</span>
        </button>
        <div className="modal-body">
          <div className="modal-teacher-image-wrapper">
            <img 
              src={teacher.image} 
              alt={teacher.name}
              className="modal-teacher-image"
            />
          </div>
          <div className="modal-teacher-info">
            <h2 className="modal-teacher-name">{teacher.name}</h2>
            <p className="modal-teacher-title">{teacher.title}</p>
            {teacher.bio && (
              <div className="modal-teacher-bio">
                <h3>Танилцуулга</h3>
                <p dangerouslySetInnerHTML={{ __html: teacher.bio }}></p>
              </div>
            )}
            {!teacher.bio && (
              <div className="modal-teacher-bio">
                <p className="no-bio-text">Танилцуулга хараахан нэмэгдээгүй байна.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TeacherModal;
